module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"country":"Страна","line1":"Адрес (строка 1)","line2":"Адрес (строка 2)","region":"Регион","city":"Населенный пункт","postcode":"Почтовый индекс"}}')
  delete Component.options._Ctor
}
